<script setup lang="ts">

defineProps({
  error: String
});

</script>

<template>
<div>
  <div v-if="error" class="text-red-500">
    {{ error }}
  </div>
</div>
</template>

<style scoped lang="scss">

</style>